export const PAGES_MENU = () => {
  return [
    {
      path: 'modulos',
      children: [
        {
          path: 'dashboard',
          data: {
            menu: {
              title: 'general.menu.dashboard',
              icon: 'ion-ios-speedometer-outline',
              selected: false,
              expanded: false,
              order: 0,
            },
          },
        },
        {
          path: 'shoppings',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.shoppings',
              icon: 'fa fa-building-o',
              selected: false,
              expanded: false,
              order: 0,
            },
          },
        },
        {
          path: 'promocoes',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.promocoes',
              icon: 'ion-ribbon-b',
              selected: false,
              expanded: false,
              order: 0,
            },
          },
        },
        {
          path: 'terminais',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.terminais',
              icon: 'ion-ios-monitor-outline',
              selected: false,
              expanded: false,
              order: 0,
            },
          },
        },
        {
          path: 'beneficios',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.beneficios.label',
              icon: 'fa fa-money',
              selected: false,
              expanded: false,
              order: 100,
            },
          },
          children: [
            {
              path: 'beneficios',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.beneficios.beneficios',
                  icon: 'fa fa-bars',
                  selected: false,
                  expanded: false,
                  order: 0,
                },
              },
            },
            {
              path: 'controle',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.beneficios.controle',
                  icon: 'fa ion-arrow-swap',
                  selected: false,
                  expanded: false,
                  order: 0,
                },
              },
            },
            {
              path: 'controlecafes',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.beneficios.controlecafes',
                  icon: 'fa fa-coffee',
                  selected: false,
                  expanded: false,
                  order: 0,
                },
              },
            },
          ],
        },
        {
          path: 'brindes',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.brindes',
              icon: 'fa fa-gift',
              selected: false,
              expanded: false,
              order: 100,
            },
          },
          children: [
            {
              path: 'produtos',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.produtos',
                  icon: 'fa fa-cube',
                },
              },
            },
            {
              path: 'estoque',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.estoque',
                  icon: 'fa fa-cubes',
                },
              },
            },
          ],
        },
        {
          path: 'pessoas',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.pessoas',
              icon: 'fa fa-address-card-o',
              selected: false,
              expanded: false,
              order: 100,
            },
          },
          children: [
            {
              path: 'tiposFuncionais',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.tipos_funcionais',
                  icon: 'fa fa-ticket',
                },
              },
            },
            {
              path: 'pessoas',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.pessoas',
                  icon: 'ion-person-stalker',
                },
              },
            },
            {
              path: 'usuarios',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.usuarios',
                  icon: 'ion-ios-people-outline',
                  selected: false,
                  expanded: false,
                  order: 0,
                },
              },
            },
          ],
        },
        {
          path: 'rotinas',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.rotinas.label',
              icon: 'fa fa-bolt',
              selected: false,
              expanded: false,
              order: 100,
            },
          },
          children: [
            {
              path: 'consultaCompras',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.consulta_compras',
                  icon: 'fa fa-shopping-cart',
                },
              },
            },
            {
              path: 'brindeAutomatico',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.brinde_automatico',
                  icon: 'fa fa-magic',
                },
              },
            },
            {
              path: 'brindeManual',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.brinde_manual',
                  icon: 'fa fa-gift',
                },
              },
            },
            {
              path: 'cupomManual',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.cupom_manual',
                  icon: 'ion-ios-pricetag-outline',
                },
              },
            },
            {
              path: 'cafeManual',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.cafe_manual',
                  icon: 'fa fa-coffee',
                },
              },
            },
            {
              path: 'almocoManual',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.almoco_manual',
                  icon: 'fa fa-cutlery',
                },
              },
            },
            {
              path: 'estacionamento',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.estacionamento',
                  icon: 'fa fa-car',
                },
              },
            },
            {
              path: 'patio',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.patio',
                  icon: 'fa fa-car',
                },
              },
            },
            {
              path: 'beneficio',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.beneficio',
                  icon: 'fa fa-check',
                },
              },
            },
            {
              path: 'reimpressao',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.rotinas.reimpressao',
                  icon: 'fa fa-print',
                },
              },
            },
          ],
        },
        {
          path: 'relatorios',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.relatorios.label',
              icon: 'ion-ios-paper-outline',
              selected: false,
              expanded: false,
              order: 100,
            },
          },
          children: [
            {
              path: 'relatorio-beneficios',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.relatorios.beneficios',
                  icon: 'ion-ios-paper-outline',
                },
              },
            },
            {
              path: 'relatorio-brindes',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.relatorios.brindes',
                  icon: 'ion-ios-paper-outline',
                },
              },
            },
            {
              path: 'relatorio-estoque',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.relatorios.estoque',
                  icon: 'ion-ios-paper-outline',
                },
              },
            },
            {
              path: 'relatorio-produtividade',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.relatorios.produtividade',
                  icon: 'ion-ios-paper-outline',
                },
              },
            },
          ],
        },
        {
          path: 'extras',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.extras.label',
              icon: 'fa fa-plus',
              selected: false,
              expanded: false,
              order: 100,
            },
          },
          children: [
            {
              path: 'roletapremiada',
              data: {
                menu: {
                  pathMatch: 'prefix',
                  title: 'general.menu.extras.roletapremiada',
                  icon: 'fa ion-ribbon-b',
                },
              },
            },
          ],
        },
        {
          path: 'configuracoes',
          data: {
            menu: {
              pathMatch: 'prefix',
              title: 'general.menu.configuracoes',
              icon: 'fa fa-cog',
              selected: false,
              expanded: false,
              order: 0,
            },
          },
        },
      ],
    },
  ];
};



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/pages/pages.menu.ts